import type { ReactChild } from 'react'
import styled from 'styled-components'

const StyledInput = styled.input`
  padding: 10px;
  width: 100%;
`

interface Props<T extends string | number> extends Pick<
  React.HTMLProps<HTMLInputElement>,
  'name' | 'type' | 'disabled'
> {
  label?: ReactChild
  value: T
  onChange: (value: string) => void
  placeholder?: string
}

const TextInput = <T extends string | number>({
  label,
  type = 'text',
  name,
  value,
  onChange,
  disabled,
  placeholder,
}: Props<T>) => (
  <div>
    {label && <div>{label}</div>}
    <StyledInput
      type={type}
      name={name}
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
      placeholder={placeholder}
    />
  </div>
)

export default TextInput
